// extracted by mini-css-extract-plugin
export var form = "fd31701f2a4582a1d3d11213536ae238-css";
export var grid = "bec596d7a1241f87141489e30ef889d2-css";